export default "__VITE_ASSET__f53500b3__"